import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Youtube, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-deep border-t border-slate-700 pt-20 pb-8 relative overflow-hidden text-white/80" data-id="element-436">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-437">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-438">
          {/* Brand Col */}
          <div className="lg:col-span-2 flex flex-col items-start" data-id="element-439">
            <Link to="/" className="inline-block mb-6" aria-label="East West University Home" data-id="element-440">
              <div className="bg-white rounded-lg px-4 py-3 shadow-md inline-block" data-id="element-441">
                <img src="https://cdn.magicpatterns.com/uploads/b1kcBeF9jP1wXprpSnfWGK/image_30.png" alt="East West University" className="h-10 w-auto object-contain" data-id="element-442" />
              </div>
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-8 max-w-sm" data-id="element-443">
              Ranked among the top universities in Bangladesh, empowering global
              minds with a North American-style curriculum and world-class
              research facilities.
            </p>
            <div className="flex space-x-4" data-id="element-444">
              <SocialIcon icon={<Facebook className="w-4 h-4" data-id="element-446" />} data-id="element-445" />
              <SocialIcon icon={<Twitter className="w-4 h-4" data-id="element-448" />} data-id="element-447" />
              <SocialIcon icon={<Linkedin className="w-4 h-4" data-id="element-450" />} data-id="element-449" />
              <SocialIcon icon={<Youtube className="w-4 h-4" data-id="element-452" />} data-id="element-451" />
            </div>
          </div>

          {/* Links Cols */}
          <div data-id="element-453">
            <h4 className="font-bold text-white mb-6 tracking-tight" data-id="element-454">
              Academics
            </h4>
            <ul className="space-y-3 text-sm text-white/70" data-id="element-455">
              <li data-id="element-456">
                <Link to="/department/cse" className="hover:text-white transition-colors flex items-center group" data-id="element-457">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-458" />{' '}
                  Faculties & Depts
                </Link>
              </li>
              <li data-id="element-459">
                <Link to="/academic-calendar" className="hover:text-white transition-colors flex items-center group" data-id="element-460">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-461" />{' '}
                  Academic Calendar
                </Link>
              </li>
              <li data-id="element-462">
                <a href="#" className="hover:text-white transition-colors flex items-center group" data-id="element-463">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-464" />{' '}
                  Library
                </a>
              </li>
              <li data-id="element-465">
                <Link to="/faculty/profile" className="hover:text-white transition-colors flex items-center group" data-id="element-466">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-467" />{' '}
                  Faculty Directory
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-468">
            <h4 className="font-bold text-white mb-6 tracking-tight" data-id="element-469">
              Admission
            </h4>
            <ul className="space-y-3 text-sm text-white/70" data-id="element-470">
              <li data-id="element-471">
                <a href="#" className="hover:text-white transition-colors flex items-center group" data-id="element-472">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-473" />{' '}
                  Undergraduate
                </a>
              </li>
              <li data-id="element-474">
                <a href="#" className="hover:text-white transition-colors flex items-center group" data-id="element-475">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-476" />{' '}
                  Graduate
                </a>
              </li>
              <li data-id="element-477">
                <a href="#" className="hover:text-gold transition-colors flex items-center group text-gold" data-id="element-478">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-479" />{' '}
                  Scholarships & Aid
                </a>
              </li>
              <li data-id="element-480">
                <a href="#" className="hover:text-white transition-colors flex items-center group" data-id="element-481">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-482" />{' '}
                  International Students
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-483">
            <h4 className="font-bold text-white mb-6 tracking-tight" data-id="element-484">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-white/70" data-id="element-485">
              <li className="flex items-start space-x-3" data-id="element-486">
                <MapPin className="w-5 h-5 text-white/50 shrink-0 mt-0.5" data-id="element-487" />
                <span data-id="element-488">
                  Aftabnagar, Dhaka-1212
                  <br data-id="element-489" />
                  Bangladesh
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-490">
                <Phone className="w-4 h-4 text-white/50 shrink-0" data-id="element-491" />
                <span data-id="element-492">+880-2-55046678</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-493">
                <Mail className="w-4 h-4 text-white/50 shrink-0" data-id="element-494" />
                <span data-id="element-495">admissions@ewubd.edu</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-700 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-xs text-white/50" data-id="element-496">
          <p data-id="element-497">
            &copy; {new Date().getFullYear()} East West University. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-498">
            <a href="#" className="hover:text-white transition-colors" data-id="element-499">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-500">
              Terms of Use
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-501">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
function SocialIcon({
  icon
}: {
  icon: React.ReactNode;
}) {
  return <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/80 hover:bg-gold hover:text-white transition-all duration-300" data-id="element-502">
      {icon}
    </a>;
}